import React, { useState, useEffect, useRef } from 'react';
import { Dialog } from "primereact/dialog";
import { InputNumber } from "primereact/inputnumber";
import { InputText } from "primereact/inputtext";
import { FloatLabel } from "primereact/floatlabel";
import { Link, Navigate, resolvePath } from "react-router-dom";
import {config} from "../shared/config";
import * as util from '../shared/commons';
import axios from "axios";
import { Button } from 'primereact/button';
import 'primeicons/primeicons.css';
import { Image } from "primereact/image";
import ShowError from "../shared/ShowError";
import { Skeleton } from 'primereact/skeleton';
import { Toast } from 'primereact/toast';
import { Col, Form, Row } from 'react-bootstrap';
import EduMonthCombo from '../combos/EduMonthCombo';
import ShowVideo from '../shared/ShowVideo';
import {
  BarChart, Bar, XAxis, YAxis, CartesianGrid,
  Tooltip, Legend, ResponsiveContainer, LabelList
} from "recharts";
import html2canvas from "html2canvas";
import jsPDF from "jspdf";
import { alignPropType } from 'react-bootstrap/esm/types';
import AnalyticChartCombo from '../combos/AnalyticChartCombo';

export default function SchoolAnalyticChart(props) {//
    const toast = useRef(null);
    const [lodingAllData, setLodingAllData] = useState(false);
    const [creating, setCreating] = useState(false);
    const [reportSettingVisible, setReportSettingVisible] = useState(false);
    const [reportVisible, setReportVisible] = useState(false);
    const [errorVisible, setErorVisible] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");
    const [chartType, setChartType] = useState("");
    const [month, setMonth] = useState(null);
    const [allScores, setAllScores] = useState(null);

    const chartRefs = useRef([]);
    const [charts, setCharts] = useState(null); 

    const data2 = [
        { name: "کلاس اول", ریاضی: 18.5, علوم: 17.2, ادبیات: 19.0 },
        { name: "کلاس دوم", ریاضی: 16.3, علوم: 15.8, ادبیات: 17.5 },
        { name: "کلاس سوم", ریاضی: 19.1, علوم: 18.6, ادبیات: 18.9 },
        { name: "کلاس چهارم", ریاضی: 14.8, علوم: 16.2, ادبیات: 15.7 },
    ];
    const options2 = {
        caption: "میانگین نمرات دروس به تفکیک کلاس‌ها",
        XAxisCaption : "کلاس ها",
        YAxisCaption:"میانگین نمره",
        scoreRange:[0, 20],
        courses:[{name:"ریاضی", color:util.lightColors[0]}, {name:"علوم", color:util.lightColors[1]}, {name:"ادبیات", color:util.lightColors[2]}]
    };

    const data4 = [
        { name: "ریاضی", "کلاس اول": 18.5, "کلاس دوم": 16.3, "کلاس سوم": 19.1, "کلاس چهارم": 14.8, "کلاس پنجم": 14.8 },
        { name: "علوم", "کلاس اول": 17.2, "کلاس دوم": 15.8, "کلاس سوم": 18.6, "کلاس چهارم": 16.2, "کلاس پنجم": 14.8 },
        { name: "ادبیات", "کلاس اول": 19.0, "کلاس دوم": 17.5, "کلاس سوم": 18.9, "کلاس چهارم": 15.7, "کلاس پنجم": 14.8 },
    ];
    const options4 = {
        caption: "میانگین نمرات دروس به تفکیک کلاس‌ها",
        XAxisCaption : "دروس",
        YAxisCaption:"میانگین نمره",
        scoreRange:[0, 20],
        classes:[{name:"کلاس اول", color:util.lightColors[0]}, {name:"کلاس دوم", color:util.lightColors[1]}, {name:"کلاس سوم", color:util.lightColors[2]}, {name:"کلاس چهارم", color:util.lightColors[3]}, {name:"کلاس پنجم", color:util.lightColors[4]}]
    };

    const data5 = [
    { name: "ریاضی", کلاس_اول: 18.5, کلاس_دوم: 16.3, کلاس_سوم: 19.1, کلاس_چهارم: 14.8 },
    { name: "علوم", کلاس_اول: 17.2, کلاس_دوم: 15.8, کلاس_سوم: 18.6, کلاس_چهارم: 16.2 },
    { name: "ادبیات", کلاس_اول: 19.0, کلاس_دوم: 17.5, کلاس_سوم: 18.9, کلاس_چهارم: 15.7 },
    { name: "زبان انگلیسی", کلاس_اول: 16.8, کلاس_دوم: 15.2, کلاس_سوم: 18.3, کلاس_چهارم: 14.5 },
    { name: "تاریخ", کلاس_اول: 17.6, کلاس_دوم: 16.4, کلاس_سوم: 18.7, کلاس_چهارم: 15.1 },
    { name: "جغرافیا", کلاس_اول: 18.1, کلاس_دوم: 17.9, کلاس_سوم: 19.0, کلاس_چهارم: 16.5 },
    { name: "هنر", کلاس_اول: 19.4, کلاس_دوم: 18.1, کلاس_سوم: 19.5, کلاس_چهارم: 17.3 },
    { name: "ورزش", کلاس_اول: 20.0, کلاس_دوم: 19.8, کلاس_سوم: 19.9, کلاس_چهارم: 19.5 },
    { name: "قرآن", کلاس_اول: 18.8, کلاس_دوم: 17.7, کلاس_سوم: 19.3, کلاس_چهارم: 16.9 },
    { name: "دینی", کلاس_اول: 18.2, کلاس_دوم: 17.4, کلاس_سوم: 18.6, کلاس_چهارم: 15.8 },
    // 👇 می‌توانی تا ۲۰ درس یا بیشتر اضافه کنی
    ];
    
    const InsideLabel = ({ x, y, width, height, className }) => (
        <text
            x={x + width / 2}
            y={y + height / 2 + 5}
            fill="#000"
            textAnchor="middle"
            fontSize={12}
            fontWeight="bold"
            transform={`rotate(-90, ${x + 30}, ${y + 40})`}
        >
            {className}
        </text>
    );
    const InsideVerticalLabel = ({ x, y, width, height, className }) => {
    const cx = x + width / 2;   // مرکز افقی ستون
    const cy = y + height / 2;  // مرکز عمودی ستون
    return (
        <text
        x={cx}
        y={cy}
        textAnchor="middle"
        dominantBaseline="middle"
        fill="#000"
        fontSize={12}
        transform={`rotate(-90, ${cx}, ${cy})`} // چرخش حول مرکز ستون
        >
        {className}
        </text>
    );
    };

        // 🔹 برچسب بالای ستون = میانگین نمره
    const TopLabel = ({ x, y, width, value }) => (
        <text
            x={x + width / 2}
            y={y - 5}
            fill="#333"
            textAnchor="middle"
            fontSize={12}
        >
            {value}
        </text>
    );


    useEffect(() => {

    }, []);

    const loadAllData = function(){
        if((month == null)||(month == {})||(month == "")||(month <= 0)){
            setErorVisible(true);
            setErrorMessage("ماه تحصیلی را مشخص نمائید");
            return;
        }
        if((chartType == "")||(chartType == null)){
            setErrorMessage("نوع نمودار را انتخاب کنید");
            setErorVisible(true);
            return false;
        }
        setLodingAllData(true);
        setReportSettingVisible(false);
        setReportVisible(false);
        var params = { login: util.getTrustedUser(), monthInd: month, chartType:chartType };
        var url = config.Server + `/school/scores/get/all`;
        console.log("params is>", params);
        console.log("url is>", url);
        axios
        .post(url, params)
        .then(res => {
            var response = res.data;
            if (response.state === "ok") {
                response = response.data;
                var scors = response;
                console.log("all scores is>", scors);
                setAllScores(scors);
                showCharts(scors);

                setLodingAllData(false);
                setReportSettingVisible(true);

            }
            else {
                setErrorMessage(response.message);
                setErorVisible(true);
                setLodingAllData(false);
            }
        })
        .catch(error => {
            setErrorMessage(error.code + "," + error.message);
            setErorVisible(true);
            setLodingAllData(false);
        });

    }
    const showCharts = function(scors){
        if(chartType == "chart_1"){
            setCharts([]);
            var chs = [];
            for(var i=0;i<scors.length;i++){
                for(var j=0;j<scors[i].schoolClasses.length;j++){
                    var cls = scors[i].schoolClasses[j];
                    var ch = {};
                    ch["caption"] = "مقایسه میانگین نمرات دروس در " + cls.schoolClass.name;
                    ch["courses"] = [];
                    var fields = [];
                    var values = [];
                    fields.push("name");
                    values.push(cls.schoolClass.name);
                    for(var k=0;k<scors[i].courses.length;k++){
                        var course = scors[i].courses[k];
                        var cName = util.ReplaceStr(course.course.name, " ", "_");
                        fields.push(cName);
                        values.push(scors[i].scores[cls.index][course.index]);
                        ch["courses"].push({name:cName, color:util.lightColors[course.index]});
                    }                    
                    var data = Object.fromEntries(fields.map((k, i) => [k, values[i]]));;


                    ch["data"] = [data];
                    ch["XAxisCaption"] = "کلاس";
                    ch["YAxisCaption"] = "میانگین نمره";
                    ch["scoreRange"] = [0, 20];
                    chs.push(ch);
                }
            }
            setCharts(chs);
        }
        else if(chartType == "chart_2"){
            setCharts([]);
            var chs = [];
            for(var i=0;i<scors.length;i++){
                var maxCourse = 3;
                if(scors[i].schoolClasses.length == 1) maxCourse = scors[i].courses.length;
                else if(scors[i].schoolClasses.length == 2) maxCourse = 5;
                else if(scors[i].schoolClasses.length == 3) maxCourse = 4;
                else if(scors[i].schoolClasses.length == 4) maxCourse = 3;
                else if(scors[i].schoolClasses.length == 5) maxCourse = 2;
                else if(scors[i].schoolClasses.length == 6) maxCourse = 2;
                else maxCourse = 1;
                var courseCo = 0;
                var ch = {data:[], classes:[]};
                for(var k=0;k<scors[i].courses.length;k++){
                    var course = scors[i].courses[k];
                    var cName = course.course.name;
                    var fields = [];
                    var values = [];
                    fields.push("name");
                    values.push(cName);
                    for(var j=0;j<scors[i].schoolClasses.length;j++){
                        var cls = scors[i].schoolClasses[j];
                        var className = util.ReplaceStr(cls.schoolClass.name, " ", "_");
                        fields.push(className);
                        values.push(scors[i].scores[cls.index][course.index]);
                        if(courseCo == 0){
                            ch["classes"].push({name:className, color:util.lightColors[cls.index]});
                        }
                    }
                    var data = Object.fromEntries(fields.map((k, i) => [k, values[i]]));;
                    ch["data"].push(data);
                    courseCo++;
                    if((k == scors[i].courses.length-1)||(courseCo == maxCourse)){
                        ch["caption"] = "مقایسه میانگین دروس در کلاس های هم سطح ";
                        ch["XAxisCaption"] = "دروس";
                        ch["YAxisCaption"] = "میانگین نمره";
                        ch["scoreRange"] = [0, 20];
                        chs.push(ch);

                        courseCo = 0;
                        ch = {data:[], classes:[]};

                    }
                }
            }
            setCharts(chs);
            console.log("charts is>", chs)
        }
        else if(chartType == "chart_3"){
            setCharts([]);
            var chs = [];
            for(var i=0;i<scors.length;i++){
                var cls = scors[i].schoolClass;
                var course = scors[i].course;
                var ch = {};
                ch["caption"] = "مقایسه نمرات دانش آموزان کلاس "+cls.name +" - درس " + course.name;
                ch["students"] = [];
                var fields = [];
                var values = [];
                fields.push("name");
                values.push("دانش آموزان");
                for(var k=0;k<scors[i].students.length;k++){
                    var student = scors[i].students[k];
                    var cName = util.ReplaceStr(student.student.firstname + " " + student.student.lastname, " ", "_");
                    fields.push(cName);
                    values.push(student.score);
                    ch["students"].push({name:cName, color:util.lightColors[k%20]});
                }                    
                var data = Object.fromEntries(fields.map((k, i) => [k, values[i]]));;


                ch["data"] = [data];
                ch["XAxisCaption"] = "دانش آموز";
                ch["YAxisCaption"] = "نمره";
                ch["scoreRange"] = [0, 20];
                chs.push(ch);
            }
            setCharts(chs);
        }

        setReportVisible(true);
    }
    const handleDownloadPDF = async () => {
        const batchSize = 5; // تعداد نمودار در هر PDF
        let batchIndex = 1;

        setCreating(true);

        for (let start = 0; start < charts.length; start += batchSize) {
            const pdf = new jsPDF("l", "mm", "a4");
            const end = Math.min(start + batchSize, charts.length);

            for (let i = start; i < end; i++) {
                const element = chartRefs.current[i];
                if (!element) continue;

                const canvas = await html2canvas(element, { scale: 2 });
                const imgData = canvas.toDataURL("image/jpeg", 0.9);

                const pdfWidth = pdf.internal.pageSize.getWidth();
                const pdfHeight = pdf.internal.pageSize.getHeight();
                const imgHeight = (canvas.height * pdfWidth) / canvas.width;

                if (i !== start) pdf.addPage();
                pdf.addImage(imgData, "JPEG", 0, 0, pdfWidth, imgHeight);

                // 🔥 آزادکردن حافظه
                canvas.width = 0;
                canvas.height = 0;
            }

            await pdf.save(`charts_part_${batchIndex}.pdf`);
            batchIndex++;

            await new Promise(r => setTimeout(r, 300)); // تاخیر کوچک برای آزادسازی RAM
        }

        setCreating(false);
    };
    const handleDownloadPDF2222 = async () => {
        const pdf = new jsPDF("l", "mm", "a4");//p->portrate, l->landscape

        console.log("start create pdf");
        setCreating(true);
        for (let i = 0; i < charts.length; i++) {
            const element = chartRefs.current[i];
            if (!element) continue;

            const canvas = await html2canvas(element, { scale: 1.5, useCORS: false, allowTaint: true, backgroundColor: "#ffffff" });
            const imgData = canvas.toDataURL("image/jpeg", 1.0);

            const pdfWidth = pdf.internal.pageSize.getWidth();
            const pdfHeight = pdf.internal.pageSize.getHeight();

            const imgWidth = pdfWidth;
            const imgHeight = (canvas.height * imgWidth) / canvas.width;

            if (i !== 0) pdf.addPage(); // 🔹 از صفحه دوم به بعد صفحه جدید اضافه کن
            pdf.addImage(imgData, "JPEG", 0, 0, imgWidth, imgHeight);
            console.log("image "+i+" add to pdf");

        }
        console.log("all images added to pdf");
        await pdf.save("نمودارها.pdf");
        setCreating(false);
    };
    const onComboChange = function(fname, e){
        if(fname === "chartType") {
          setChartType(e);
          setReportVisible(false);
        }
    }

    return(      
      <>
        <div className="page-caption" style={{ width:"calc(100% - 0px)"}}>ایجاد گزارشات تحلیلی</div>
        <div className="" style={{ width:"calc(100% - 0px)"}}>
          <div style={{backgroundColor:'#e9edffff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
              <Row>
                <Col md={3}>
                  <EduMonthCombo value={month} onChange={(value)=>{setMonth(value)}} />
                </Col>
                <Col md={6}>
                  <AnalyticChartCombo value={chartType} onChange={(e)=>{onComboChange("chartType", e)}} />
                </Col>
                <Col md={3} style={{paddingTop:"30px"}}>
                  <Button icon="pi pi-check" label='مشاهده نمودار(ها)' loading={lodingAllData} rounded severity="primary" style={{width:"200px", margin: "0px 3px", float:"right" }} onClick={() => {loadAllData()}} />
                </Col>
              </Row>
          </div>
        </div>

        {
            // reportSettingVisible?
            // <>
            //     <div className="" style={{ width:"calc(100% - 0px)"}}>
            //     <div style={{backgroundColor:'#f6fdf2ff', padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
            //         <Row>
            //             <Col md={4}>
            //             <AnalyticChartCombo value={chartType} onChange={(e)=>{onComboChange("chartType", e)}} />
            //             </Col>
            //             <Col md={3} style={{paddingTop:"30px"}}>
            //             <Button icon="pi pi-check" label='مشاهده نمودار(ها)' loading={lodingAllData} rounded severity="primary" style={{width:"200px", margin: "0px 3px", float:"right" }} onClick={() => {showCharts()}} />
            //             </Col>
            //         </Row>
            //     </div>
            //     </div>
            
            // </>
            // :
            // <></>
        }

        {
            reportVisible?
            <>
                {
                    chartType=="chart_1"?
                    <>
                    {
                        charts.map((ch, index)=>{
                            return(
                                <div className="w-full p-4 bg-white" ref={(el) => (chartRefs.current[index] = el)}>
                                    <br/><br/><br/><br/><br/><br/><br/>
                                    <h2 className="text-xl font-bold text-center mb-4">
                                        {ch.caption}
                                    </h2>

                                    <ResponsiveContainer width="100%" minWidth={600} height={600}>
                                        <BarChart
                                        data={ch.data}
                                        margin={{ top: 30, right: 30, left: 20, bottom: 40 }}
                                        >
                                         <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis
                                            dataKey="name"
                                            tick={{ fontSize: 13 }}
                                            label={{
                                            value: ch.XAxisCaption,
                                            position: "insideBottom",
                                            dy: 25,
                                            }}
                                        />
                                        <YAxis domain={ch.scoreRange} label={{
                                            value: ch.YAxisCaption,
                                            angle: -90,
                                            position: "insideLeft",
                                            dy: 40,
                                        }} /> 
                                         {/* <Tooltip />  */}
                                        {
                                            ch.courses.map((course, index)=>{
                                                return(
                                                    <Bar dataKey={course.name} fill={course.color}>
                                                        <LabelList dataKey={course.name} content={(p) => <TopLabel {...p} />} />
                                                        <LabelList content={(p) => <InsideVerticalLabel {...p} className={course.name} />} />
                                                    </Bar>
                                                )
                                            })
                                        }
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            )
                        })
                    }
                    </>
                    :
                    <></>
                }
                {
                    chartType=="chart_2"?
                    <>
                    {
                        charts.map((ch, index)=>{
                            return(
                                <div className="w-full p-4 bg-white" ref={(el) => (chartRefs.current[index] = el)}>
                                    <h2 className="text-xl font-bold text-center mb-4">
                                        {ch.caption}
                                    </h2>

                                    <ResponsiveContainer width="100%" height={600}>
                                        <BarChart
                                        data={ch.data}
                                        margin={{ top: 30, right: 30, left: 20, bottom: 40 }}
                                        >
                                        <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis
                                            dataKey="name"
                                            tick={{ fontSize: 13 }}
                                            label={{
                                            value: ch.XAxisCaption,
                                            position: "insideBottom",
                                            dy: 25,
                                            }}
                                        />
                                        <YAxis domain={[0, 20]} label={{
                                            value: ch.YAxisCaption,
                                            angle: -90,
                                            position: "insideLeft",
                                            dy: 40,
                                        }} />
                                        {/* <Tooltip /> */}
                                        {
                                            ch.classes.map((cls, index)=>{
                                                return(
                                                    <Bar dataKey={cls.name} fill={cls.color}>
                                                        <LabelList dataKey={cls.name} content={(p) => <TopLabel {...p} />} />
                                                        <LabelList content={(p) => <InsideVerticalLabel {...p} className={cls.name} />} />
                                                    </Bar>
                                                )
                                            })
                                        }
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            )
                        })
                    }
                    </>
                    :
                    <></>
                }
                {
                    chartType=="chart_3"?
                    <>
                    {
                        charts.map((ch, index)=>{
                            return(
                                <div className="w-full p-4 bg-white" ref={(el) => (chartRefs.current[index] = el)}>
                                    <br/><br/><br/><br/><br/><br/><br/>
                                    <h2 className="text-xl font-bold text-center mb-4">
                                        {ch.caption}
                                    </h2>

                                    <ResponsiveContainer width="100%" minWidth={600} height={600}>
                                        <BarChart
                                        data={ch.data}
                                        margin={{ top: 30, right: 30, left: 20, bottom: 40 }}
                                        >
                                         <CartesianGrid strokeDasharray="3 3" />
                                        <XAxis
                                            dataKey="name"
                                            tick={{ fontSize: 13 }}
                                            label={{
                                            value: ch.XAxisCaption,
                                            position: "insideBottom",
                                            dy: 25,
                                            }}
                                        />
                                        <YAxis domain={ch.scoreRange} label={{
                                            value: ch.YAxisCaption,
                                            angle: -90,
                                            position: "insideLeft",
                                            dy: 40,
                                        }} /> 
                                         {/* <Tooltip />  */}
                                        {
                                            ch.students.map((student, index)=>{
                                                return(
                                                    <Bar dataKey={student.name} fill={student.color}>
                                                        <LabelList dataKey={student.name} content={(p) => <TopLabel {...p} />} />
                                                        <LabelList content={(p) => <InsideVerticalLabel {...p} className={student.name} />} />
                                                    </Bar>
                                                )
                                            })
                                        }
                                        </BarChart>
                                    </ResponsiveContainer>
                                </div>
                            )
                        })
                    }
                    </>
                    :
                    <></>
                }
                
                <div className="" style={{ width:"calc(100% - 0px)"}}>
                <div style={{padding:'5px', borderRadius:'5px', width:"100%", display:'flow-root'}}>
                    <Row>
                        <Col md={3} style={{paddingTop:"30px"}}>
                            <Button icon="pi pi-pdf" label='خروجی pdf' loading={creating} rounded severity="success" style={{width:"180px", margin: "0px 3px", float:"right" }} onClick={() => {handleDownloadPDF()}} />
                        </Col>
                    </Row>
                    <Row>
                        <Col md={12} style={{paddingTop:"30px"}}>
                            هر پنج نمودار در یک فایل pdf قرار می گیرند. لطفا برای دریافت فایل های pdf صبور باشید
                        </Col>
                    </Row>
                </div>
                </div>
            </>
            :
            <></>
        }

       
        <ShowError visible={errorVisible} message={errorMessage} closeError={()=>{setErorVisible(false)}} />
      </>  
    );
  
}
